export default {
    topics: [
        {
            title: ' Cancel ',
            href: 'sm-asset-Cancel.html',
            attributes: { 'data-id': 'sm-asset-Cancel' },
            menu: { hasChildren: false },
            tocID: 'sm-asset-Cancel-d66e2127',
            topics: [],
        },
        {
            title: ' CheckValidationAccess ',
            href: 'sm-asset-CheckValidationAccess.html',
            attributes: { 'data-id': 'sm-asset-CheckValidationAccess' },
            menu: { hasChildren: false },
            tocID: 'sm-asset-CheckValidationAccess-d66e2135',
            topics: [],
        },
        {
            title: ' Lock ',
            href: 'sm-asset-Lock.html',
            attributes: { 'data-id': 'sm-asset-Lock' },
            menu: { hasChildren: false },
            tocID: 'sm-asset-Lock-d66e2143',
            topics: [],
        },
        {
            title: ' Publication ',
            href: 'sm-asset-Publication.html',
            attributes: { 'data-id': 'sm-asset-Publication' },
            menu: { hasChildren: false },
            tocID: 'sm-asset-Publication-d66e2151',
            topics: [],
        },
        {
            title: ' StartValidation ',
            href: 'sm-asset-StartValidation.html',
            attributes: { 'data-id': 'sm-asset-StartValidation' },
            menu: { hasChildren: false },
            tocID: 'sm-asset-StartValidation-d66e2159',
            topics: [],
        },
        {
            title: ' Unlock ',
            href: 'sm-asset-Unlock.html',
            attributes: { 'data-id': 'sm-asset-Unlock' },
            menu: { hasChildren: false },
            tocID: 'sm-asset-Unlock-d66e2167',
            topics: [],
        },
        {
            title: ' Validation ',
            href: 'sm-asset-Validation.html',
            attributes: { 'data-id': 'sm-asset-Validation' },
            menu: { hasChildren: false },
            tocID: 'sm-asset-Validation-d66e2175',
            topics: [],
        },
    ],
};

